<template>
  <div class="container">
    <h4 class="title is-4">Timestamp Converter</h4>
    <div class="container has-text-left">
      <div class="block">
        <b-field label="Timestamp">
          <b-input v-model="timestamp"/>
        </b-field>
      </div>
      <div class="buttons">
        <b-button type="is-primary" class="is-small" @click="handleClickCurrent">Current Timestamp</b-button>
        <b-button type="is-success" class="is-small" @click="handleClickConvert">Convert</b-button>
      </div>
    </div>
    <div v-if="convertClicked" class="container has-text-left">
      <hr />
      <div>Current Local Time: {{displayedRequestLocalTime}}</div>
      <div>UTC: {{displayedUTCTime}}</div>
      <div>Local: {{displayedLocalTime}}</div>
      <div>Relative: {{displayedRelativeTime}}</div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';

  import BField from "buefy/src/components/field/Field";
  import BInput from "buefy/src/components/input/Input";
  import BButton from "buefy/src/components/button/Button";

  export default {
    components: {
      BButton,
      BInput,
      BField
    },
    name: "screentimestamp",
    data() {
      return {
        initialTimestamp: 0,
        timestamp: 0,
        timestampClicked: 0,
        convertClicked: false
      };
    },
    computed: {
      displayedRequestLocalTime() {
        return `${moment.unix(this.timestampClicked, 'X').format('YYYY-MM-DD HH:mm:ss')}`;
      },
      displayedUTCTime() {
        return `${moment.utc(this.timestamp, 'X').format('YYYY-MM-DD HH:mm:ss')}`;
      },
      displayedLocalTime() {
        return `${moment.unix(this.timestamp).format('YYYY-MM-DD HH:mm:ss')}`;
      },
      displayedRelativeTime() {
        const mom = moment.unix(this.timestamp);
        return `${mom.startOf('seconds').fromNow()}`;
      }
    },
    methods: {
      handleClickCurrent() {
        this.timestamp = parseInt(moment().format('X'), 10);
      },
      handleClickConvert() {
        this.convertClicked = true;
        this.timestampClicked = parseInt(moment().format('X'), 10);
      }
    },
    mounted() {
      this.initialTimestamp = parseInt(moment().format('X'), 10);
      this.timestamp = this.initialTimestamp;
      this.convertClicked = false;
    },
    unmounted() {
      this.convertClicked = false;
    }
  }
</script>

<style scoped>

</style>